import { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { BarLoader, ClockLoader } from 'react-spinners';
import '../styling/backdrop.css';
// import Lightbox from "yet-another-react-lightbox-lite";
// import "yet-another-react-lightbox-lite/styles.css";
import { TostMessageContext } from "../context/TostMessage";

export function FulfillOrder({ showModal, setShowModal, showDetails }) {
    const [pageLoading, setPageLoading] = useState(false);
    const [cookies, ] = useCookies();
    const [cartItems, setCartItems] = useState(showDetails?.row?.order_items);
    const [formFields, setFormFields] = useState({});
        // const [open, setOpen] = React.useState(false);
    const [stockQty, setStockQty] = useState({});
    const {setTostMessage} = useContext(TostMessageContext);

    useEffect(() => {
        // getData();
    }, [])

    useEffect(() => {
        if (!cartItems?.length) return;

        const stockMap = {};

        cartItems.forEach(item => {
            stockMap[item.product_id] = getStock(item.product_id);
        });

        setStockQty(stockMap);
    }, [cartItems]);

    async function getStock(prod_id) {
        const formData = new FormData();
        formData.append('product_id', prod_id);
        try {
            const response = await axios.post(base_url + '/get_item_stock.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.status) {
                return response.data.in_stock;
            } else {
                return 'N/A'
            }
        } catch (error) {
          return 'N/A'
        }
    }

    async function fulfillOrder() {
        const formData = new FormData();
        formData.append('order_id', showDetails?.row?.id);
        Object.entries(formFields).forEach(([key, value]) => {
            formData.append(key, value);
        });

        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/fulfill_order.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.status) {
                setShowModal(false);
                setTostMessage({
                    messageType: 'success',
                    message: response.data.message
                })
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
            setTostMessage({
                messageType: 'error',
                message: 'Network error'
            })
        }
    }

    useEffect(() => {
        if (pageLoading) return;

    }, [pageLoading]);


  return (
        <div className='backdrop flex justify-center items-center w-fill-available h-full fixed top-0'>
            <div className='flex flex-col items-center py-7 px-5 h-full overflow-y-auto w-[100%] lg:w-[45%] fixed right-0 bg-white animate-scaleIn'>
                <div onClick={() => setShowModal(false)} className='w-auto self-end flex justify-end text-underline text-[#ff0000] cursor-pointer'>Close</div>
                <a className='text-dark text-[20px] font-bold'>{'Fulfill Order'}</a>
                {pageLoading &&
                    <div className="h-full w-full bg-white flex items-center justify-center">
                        <BarLoader 
                            color={'#7d5af6'}
                            loading={true}
                            size={10}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                    </div>
                }
                {!pageLoading &&
                <>
                    <div className="w-full space-y-6 mt-5">
                    {cartItems?.map((item, index) => (
                        <div
                            key={index}
                            className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6 border rounded-lg p-4"
                        >
                            {/* Product */}
                            <div className="flex items-center gap-4 w-auto max-w-[65%]">
                                <img
                                    src={item.thumbnail}
                                    alt={item.name}
                                    className="w-16 h-16 object-contain"
                                />

                                <div className='w-auto flex flex-col'>
                                    <p className="font-medium">{item.name}</p>
                                    <p className="text-xs md:text-sm font-regular text-[#585858]">{item.selected_extras}</p>
                                </div>
                            </div>
                            
                            {/* Quantity */}
                            {/* <div className="md:w-1/6">
                            <input
                                type="number"
                                min="1"
                                value={item.quantity}
                                onChange={(e) =>
                                updateQty(index, Number(e.target.value))
                                }
                                className="w-20 border rounded px-2 py-1"
                            />
                            </div> */}

                            {/* Subtotal */}
                            <div className="w-auto font-medium">
                                <p className='text-xs md:text-sm font-regular text-[#585858]'>Order Qty</p>
                                {item.qty}
                                <p className='text-xs md:text-sm font-regular text-[#585858]'>In Stock</p>
                                {stockQty?.[item.product_id] ?? 'Checking stock..'}
                            </div>

                            {/* In Stock */}
                            {/* <div className="md:w-1/6 font-medium">
                            <p className='text-xs md:text-sm font-regular text-[#585858]'>In Stock</p>
                            {stockQty?.[item.product_id] ?? 'Checking stock..'}
                            </div> */}

                        </div>
                        ))}
                        <div className="w-auto font-medium">
                            <p className='text-xs md:text-sm font-regular text-[#585858]'>Order Amount</p>
                            <p>{showDetails?.row?.order_amount}</p>
                        </div>
                        <div className="w-auto font-medium">
                            <p className='text-xs md:text-sm font-regular text-[#585858]'>Delivery To</p>
                            <p>{showDetails?.row?.shipping_addr}</p>
                        </div>
                        <div className="w-auto font-medium">
                            <p className='text-xs md:text-sm font-regular text-[#585858]'>Customer</p>
                            <p>{showDetails?.row?.full_name}</p>
                            <p>{showDetails?.row?.email}</p>
                            <p>{showDetails?.row?.phone_number}</p>
                        </div>

                        <div className="w-[80%] mx-auto flex flex-col mt-2">
                            <label>Select Outlet</label>
                            <select
                                className="w-full mx-auto border p-2 rounded my-2"
                                onChange={(e) => setFormFields({...formFields, location_id: e.target.value})}
                            >
                                <option value="">Choose Outlet</option>
                                {cookies?.userProfile?.locations?.map((item, index) => 
                                    <option key={index} value={item.location_id}>{item.name}</option>
                                )}
                            </select>
                        </div>

                        <div className="w-[80%] mx-auto flex flex-col mt-2">
                            <label>Add Shipping Tracking Link (Optional)</label>
                            <input type='url' onChange={(e) => setFormFields({...formFields, tracking_link: e.target.value})} className="w-full mx-auto border p-2 rounded my-2" placeholder="Paste tracking link" />
                        </div>

                        <div className='w-[80%] mx-auto mt-3'>
                            <button onClick={() => !showDetails?.row?.isFulfilled ? fulfillOrder() : null } className={`w-full flex-1 bg-[#dd4039] ${showDetails?.row?.isFulfilled && 'opacity-[0.5]'} text-white py-3 rounded-full`}>
                                <span className="font-bold">Fulfil Order</span> Now
                            </button>
                        </div>
                    </div>
                </>
                }
            </div>  
        </div>
    )
}
